import { all, fork, takeLatest } from 'redux-saga/effects';
import { fetchDetail, fetchTable, sendData } from '../helpers/sagaHelpers';

function* watchFetchAssignSolverTable() {
  yield takeLatest('assignSolver/fetchTable', fetchTable);
}
function* watchFetchAssignSolverDetail() {
  yield takeLatest('assignSolver/fetchDetail', fetchDetail);
}

function* watchSubmitAssignSolverDetail() {
  yield takeLatest('assignSolver/submitDetail', sendData);
}

export default function* rootSaga() {
  yield all([
    fork(watchFetchAssignSolverTable),
    fork(watchFetchAssignSolverDetail),
    fork(watchSubmitAssignSolverDetail)
  ]);
}
